var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyplIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003087;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.8,538.1v-195h77c14.8,0,27.4,2.8,37.8,8.4c10.4,5.6,18.4,13.4,23.9,23.3c5.5,9.9,8.2,21.4,8.2,34.3 s-2.8,24.4-8.4,34.3c-5.6,9.9-13.7,17.6-24.2,23.1s-23.3,8.3-38.3,8.3h-49v-33h42.4c7.9,0,14.5-1.4,19.7-4.1s9-6.6,11.6-11.5 c2.6-4.9,3.9-10.6,3.9-17c0-6.5-1.3-12.1-3.9-17c-2.6-4.9-6.5-8.6-11.7-11.3c-5.2-2.7-11.8-4-19.8-4h-27.8v161.3H121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.4,343.1h46.2l44.5,84h1.9l44.5-84h46.2l-71.1,126.1v69h-41v-69L274.4,343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.5,538.1v-195h77c14.8,0,27.4,2.8,37.8,8.4c10.4,5.6,18.4,13.4,23.9,23.3c5.5,9.9,8.2,21.4,8.2,34.3 s-2.8,24.4-8.4,34.3c-5.6,9.9-13.7,17.6-24.2,23.1s-23.3,8.3-38.3,8.3h-49v-33h42.4c7.9,0,14.5-1.4,19.7-4.1s9-6.6,11.6-11.5 c2.6-4.9,3.9-10.6,3.9-17c0-6.5-1.3-12.1-3.9-17c-2.6-4.9-6.5-8.6-11.7-11.3c-5.2-2.7-11.8-4-19.8-4h-27.8v161.3H470.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M634.5,538.1v-195h41.2v161h83.6v34H634.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyplIcon);
export default __webpack_public_path__ + "static/media/pypl_icon.d5003afa69c022e59e6ad4d47175e934.svg";
export { ForwardRef as ReactComponent };